// What the pro is actually being offered: the rider's open counter, then the accepted counter (either side), then the estimate.
export function tripFare(t) {
  if (!t) return null;
  const offers = Array.isArray(t.offers) ? t.offers : [];
  const open = [...offers].reverse().find((o) => o?.status === "open" && (o?.by === "rider" || o?.by === "customer") && Number(o.amount) > 0);
  const accepted = [...offers].reverse().find((o) => o?.status === "accepted" && Number(o.amount) > 0);
  const v = open?.amount ?? accepted?.amount ?? t.accepted_offer_amount ?? t.proposed_fare ?? t.estimated_fare;
  return v == null ? null : Number(v);
}

const openRiderOffer = (t) => [...(Array.isArray(t?.offers) ? t.offers : [])].reverse()
  .find((o) => o?.status === "open" && (o?.by === "rider" || o?.by === "customer") && Number(o.amount) > 0);

// The estimate the customer saw when making the offer (that pro's own fare when they picked one pro).
export function tripEstimate(t) {
  const v = openRiderOffer(t)?.estimate ?? t?.estimated_fare;
  return v == null ? null : Number(v);
}

export const isRiderOffer = (t) => {
  const f = tripFare(t);
  const e = tripEstimate(t);
  return f != null && e != null && Math.abs(f - e) >= 0.01;
};
